<template>
  <b-row>
    <b-col sm="6" class="form-group">
      <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
        :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
      </form-write-group-label-input>
    </b-col>
  </b-row>
</template>
<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'InterProcessConfigurationForm',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val
        }
      }
    }
    },
  data () {

  },
  created () {
  },
  methods: {

  }
}
</script>
